module.exports = __webpack_public_path__ + "static/media/Log_tela.873f6442.jpg";